<template>
  <v-dialog :value="value" :fullscreen="$vuetify.breakpoint.smAndDown" max-width="900" scrollable @input="$emit('input', $event)">
    <v-card>
      <v-card-title class="news-pdf__title">
        <span class="news-pdf__name">{{ attachment.name }}</span>
        <v-spacer></v-spacer>
        <v-btn icon aria-label="Cerrar" title="Cerrar" @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="news-pdf__body" @contextmenu.prevent>
        <div v-if="loading" class="pa-6 text-center">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <p v-if="error" class="pa-6 text-center">{{ error }}</p>
        <div ref="pages" class="news-pdf__pages"></div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { newsService } from "@/libs/ws/newsService";

const MAX_RENDER_WIDTH = 1400;

// Dibuja el PDF en canvas: el visor del navegador trae su propio botón de descarga
export default {
  name: "NewsPdfViewer",
  props: {
    value: Boolean,
    attachment: Object,
  },
  data() {
    return {
      loading: false,
      error: "",
    };
  },
  watch: {
    value: {
      immediate: true,
      handler(open) {
        if (open) this.$nextTick(() => this.load());
        else this.clear();
      },
    },
  },
  beforeDestroy() {
    this.clear();
  },
  methods: {
    async load() {
      const load_id = (this.load_id = (this.load_id || 0) + 1);
      this.loading = true;
      this.error = "";
      try {
        const response = await newsService.file(this.attachment);
        if (!response.status) throw new Error(response.msg);
        const data = new Uint8Array(await response.blob.arrayBuffer());

        const pdfjs = await import(/* webpackChunkName: 'pdfjs-dist' */ "pdfjs-dist/webpack");
        const pdf = await pdfjs.getDocument({ data });
        if (load_id != this.load_id) {
          pdf.destroy();
          return;
        }
        this.pdf = pdf;

        for (let number = 1; number <= pdf.numPages; number++) {
          const page = await pdf.getPage(number);
          if (load_id != this.load_id) return;
          await this.drawPage(page);
          if (load_id != this.load_id) return;
          this.loading = false;
        }
      } catch (e) {
        if (load_id == this.load_id) this.error = "No se pudo abrir el archivo.";
      } finally {
        if (load_id == this.load_id) this.loading = false;
      }
    },
    drawPage(page) {
      const available = Math.min(this.$refs.pages.clientWidth * (window.devicePixelRatio || 1), MAX_RENDER_WIDTH);
      const viewport = page.getViewport(available / page.getViewport(1).width);

      const canvas = document.createElement("canvas");
      canvas.width = viewport.width;
      canvas.height = viewport.height;
      canvas.className = "news-pdf__page";
      this.$refs.pages.appendChild(canvas);

      return page.render({ canvasContext: canvas.getContext("2d"), viewport });
    },
    clear() {
      // Corta una carga en curso y libera el documento de memoria
      this.load_id = (this.load_id || 0) + 1;
      if (this.pdf) this.pdf.destroy();
      this.pdf = null;
      if (this.$refs.pages) this.$refs.pages.innerHTML = "";
    },
  },
};
</script>

<style>
/* Sin scoped: los canvas se crean por código */
.news-pdf__page {
  display: block;
  width: 100%;
  margin-bottom: 12px;
  box-shadow: 0 1px 4px rgba(15, 23, 42, 0.2);
}
</style>

<style scoped>
.news-pdf__title {
  flex-wrap: nowrap;
}
.news-pdf__name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.news-pdf__body {
  padding: 12px !important;
  background: #f1f5f9;
  -webkit-touch-callout: none;
}
</style>
